import Box from '@mui/material/Box';
import { Icon } from 'assets/Icon.js';
import EWFLogo from 'assets/images/logo.png?url';

import {
  Description,
  StyledDrawer,
  Wrapper,
} from './BrandingSidebar.styled.js';

export const BrandingSidebar = () => {
  return (
    <StyledDrawer open={true} anchor="left" variant="permanent">
      <Wrapper>
        <Icon icon="safIconDarkSvg" sx={{ height: 48 }} />
        <Description data-sentry-unmask>
          Bringing consistency and transparency to the SAF certificate market
        </Description>
        <Box
          height="100%"
          display="flex"
          alignItems="flex-end"
          justifyContent="center"
        >
          <img src={EWFLogo} alt="EWF logo" style={{ width: 171, height: 'auto' }} />
        </Box>
      </Wrapper>
    </StyledDrawer>
  );
};
